export const sideMenuWidth = 60;
